export const normalizeMobile = (mobile: string): string => mobile?.substr(1, mobile.length - 1);